import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { PlaybookMyStepsPage } from '@/features/playbooks/components/PlaybookMyStepsPage';

export const Route = createFileRoute('/_authenticated/playbooks/tasks/mine')({
  beforeLoad: async () => {
    await requireFeature(FeatureKey.CLIENT_PLAYBOOKS);
  },
  component: PlaybookMyStepsRoute,
});

function PlaybookMyStepsRoute() {
  return (
    <PermissionGate permission={Permission.PLAYBOOKS_VIEW}>
      <PlaybookMyStepsPage />
    </PermissionGate>
  );
}
